"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stringIsValidBase = (value) => ['primary', 'secondary', 'black'].includes(value);
const formatShadeString = (value) => {
    if (['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'].includes(value)) {
        return Number(value);
    }
    if (['A100', 'A700'].includes(value)) {
        return value;
    }
    throw new Error(`Invalid shade value ${value}`);
};
const getControlsColorSpecificationByString = (specification) => {
    const shadeBaseRegex = 'primary|secondary|black';
    const shadeValueRegex = '50|100|200|300|400|500|600|700|800|900|A100|A700';
    const shadeAlphaRegex = '[0-1]|[0-9].[0-9]|[0-9].[0-9][0-9]';
    const paletteBaseRegex = `palette:(${shadeBaseRegex}):(${shadeValueRegex})`;
    if (new RegExp(`^${paletteBaseRegex}$`).test(specification)
        || new RegExp(`^${paletteBaseRegex}:(${shadeAlphaRegex})$`)
            .test(specification)) {
        const [, base, shade, alpha] = specification.split(':');
        if (stringIsValidBase(base)) {
            const colorSpec = {
                type: 'palette',
                value: {
                    base,
                    shade: formatShadeString(shade),
                    alpha: Number(alpha || '1'),
                },
            };
            return colorSpec;
        }
    }
    if (/^custom:[#A-Za-z0-9]+$/.test(specification)) {
        const components = specification.split(':');
        const colorCustom = {
            type: 'custom',
            value: components[1],
        };
        return colorCustom;
    }
    return undefined;
};
exports.default = getControlsColorSpecificationByString;
